import { useTranslation } from 'sierra-client/hooks/use-translation'
import { getGlobalRouter } from 'sierra-client/router'
import { ProgramOverview, Start } from 'sierra-client/views/course-helper/content/actions'
import { CourseFallback } from 'sierra-client/views/course-helper/content/fallback/fallback'
import { NextUpCourseInPathOrProgram } from 'sierra-client/views/course-helper/content/next-course-in-path-or-program'
import { HelperContent } from 'sierra-client/views/course-helper/shared/shared'
import { useSelfPacedFiles } from 'sierra-client/views/self-paced/files-provider'
import { Text, View } from 'sierra-ui/primitives'

export const NextCourseInProgram: React.FC = () => {
  const { t } = useTranslation()
  const { nextUp, goToNextUp } = useSelfPacedFiles()

  if (nextUp.type !== 'next-course-in-program') return <CourseFallback />

  const programTitle = nextUp.programTitle

  const goToProgramIdPage = (): void =>
    void getGlobalRouter().navigate({
      to: '/program/$programId',
      params: { programId: nextUp.programId },
    })

  return (
    <HelperContent title={t('helper.program-pending')} icon='racing--flag'>
      <Text color='foreground/secondary' bold>
        {t('helper.next-up-in', {
          title: programTitle,
        })}
      </Text>

      <NextUpCourseInPathOrProgram
        course={nextUp.course}
        courseTitle={nextUp.courseTitle}
        goToNextUp={() => goToNextUp(nextUp)}
        goToOverViewPage={() =>
          getGlobalRouter().navigate({
            to: '/program/$programId',
            params: { programId: nextUp.programId },
          })
        }
        buttons={
          <View grow justifyContent='flex-end' gap='8'>
            <ProgramOverview onClick={goToProgramIdPage} />
            <Start onClick={() => goToNextUp(nextUp)} />
          </View>
        }
      />
    </HelperContent>
  )
}
